export const collectNumbers = (name, type, data, memberNumber) => {
  if (name === "MOBILE_NUMBER") {
    if (type === "TEAM_LEADER") {
      return {
        type: "TEAM_LEADER_MOBILE_NUMBER",
        payload: data
      }
    } else {
      return {
        type: `TEAM_MEMBER_${memberNumber}_MOBILE_NUMBER`,
        payload: data,
        index: memberNumber
      }
    }
  } else if (name === "TARGET_AMOUNT") {
    if (type === "TEAM_LEADER") {
      return {
        type: "TEAM_LEADER_TARGET_AMOUNT",
        payload: data
      }
    }
  }
}
